var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3275",
    "data-name": "Group 3275",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.441,
    height: 16.8,
    viewBox: "0 0 15.441 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8496",
    "data-name": "Path 8496",
    d: "M2.7,13.025h-.34A1.357,1.357,0,0,1,1,11.667V8.273H2.7a2.376,2.376,0,0,1,0,4.752Z",
    transform: "translate(-0.067 -0.552)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8497",
    "data-name": "Path 8497",
    d: "M14.576,13.025H13.557a2.376,2.376,0,0,1,0-4.752h1.7v4.073A.679.679,0,0,1,14.576,13.025Z",
    transform: "translate(-0.745 -0.552)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8498",
    "data-name": "Path 8498",
    d: "M1,7.788a6.788,6.788,0,1,1,13.575,0v4.073A4.072,4.072,0,0,1,10.5,15.933H7.788v-.679",
    transform: "translate(-0.067 -0.067)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.512e0579f85974b9f0cabb9e49a1b773.svg";
export { ForwardRef as ReactComponent };